import React, { useEffect, useState } from "react";
import {
  Layout,
  Button,
  PageHeader,
  Form,
  Input,
  Upload,
  TimePicker,
  Switch,
  Select,
  Radio,
  message,
  Space,
  Row,
  Col,
} from "antd";
import _ from "lodash";
import R2Footer from "../../components/Footer";
import { useHistory, useParams } from "react-router";
import MenuService from "../../services/MenuService";
import DashboardService from "../../services/DashboardService";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import moment from "moment";
import { useLocation } from "react-router-dom";
const { Content } = Layout;


const modes = { create: "create", edit: "edit" };
const fieldList = [
  "name",
  "type",
  "photo_url",
  "restaurant_ids",
  "start_time",
  "end_time",
];

const MenuForm = (props) => {
  const [mode, setMode] = useState(modes.create);
  const { Option } = Select;
  const history = useHistory();
  const params = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [menuItems, setMenuItems] = useState({});
  const [restaurants, setRestaurants] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isCatering = queryParams.get("isCatering") === "true";

  
  const validateForm = () => {
    let isValidate = true;
    fieldList.map((field) => {
      if (!menuItems[field]) {
        isValidate = false;
      }
      return null;
    });
    return isValidate;
  };

  const getAllrestaurents = async () => {
    const getRestaurants = await DashboardService.getRestaurantsByUser();
    setRestaurants(getRestaurants);
  };
  useEffect(() => {
    checkMenuItem();
    getAllrestaurents();
  }, []);

  const checkMenuItem = async () => {
    if (params.menuId) {
      setLoading(true);
      const menuItem = await MenuService.getMenu(parseInt(params.menuId));
      // form.setFieldsValue({menuItem});
      setMenuItems(menuItem);
      setLoading(false);
    }
  };

  const onUpdateValue = (e) => {
    const menuList = _.cloneDeep(menuItems);
    menuList[e.target.name] = e.target.value;
    setMenuItems(menuList);
  };
  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const formData = new FormData();
    formData.append("file", file);
    const urlResponse = await MenuService.uploadMenuItemPhoto(formData);
    const menuList = _.cloneDeep(menuItems);
    menuList.photo_url = urlResponse.url;
    setMenuItems(menuList);
    onSuccess(true);
  };
  const submitForm = async () => {
    if (validateForm()) {
      setLoading(true);
      if (params.menuId) {
        const responseUpdate = await MenuService.updateMenu(
          {
            photo_url: menuItems.photo_url || "",
            name: menuItems.name,
            type: menuItems.type,
            restaurant_ids: menuItems.restaurant_ids,
            is_default: menuItems.is_default,
            start_time: menuItems.start_time ? menuItems.start_time : null,
            end_time: menuItems.end_time ? menuItems.end_time : null,
          },
          params.menuId
        );
      } else {
        const response = await MenuService.addMenu({
          photo_url: menuItems.photo_url || "",
          name: menuItems.name,
          restaurant_ids: menuItems.restaurant_ids,
          is_default: menuItems.is_default,
          type: menuItems.type,
          start_time: menuItems.start_time,
          end_time: menuItems.end_time,
        });
      }

      setLoading(false);
      // form.resetFields();
      history.goBack();
    } else {
      messageApi.open({
        type: "error",
        content: "Please enter all the fields and upload image",
        duration: 1,
      });
    }
  };
  const onTimeChange = (time, label) => {
    const menuList = _.cloneDeep(menuItems);
    menuList[label] = time;
    setMenuItems(menuList);
  };
  const onMenuChange = (e) => {
    const menuList = _.cloneDeep(menuItems);
    menuList.type = e.target.value;
    setMenuItems(menuList);
  };
  const onActivate = () => {
    const menuList = _.cloneDeep(menuItems);
    menuList.is_default = !menuList.is_default;
    setMenuItems(menuList);
  };
  const onSelectChange = (id) => {
    const menuList = _.cloneDeep(menuItems);
    menuList.restaurant_ids = id;
    setMenuItems(menuList);
  };
  return (
    <Layout className="u-page-layout">
      {contextHolder}
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            style={{ minHeight: 80 }}
            className="d-flex items-center page-header-business"
            title={
              <div className="flex items-center">
                <div
                  className="cursor-pointer flex"
                  onClick={() => history.goBack()}
                >
                  <svg
                    width="25"
                    height="16"
                    viewBox="0 0 25 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="ml-1 ant-page-header-heading-title">
                  {params.menuId ? "Edit Menu" : "Add Menu"}
                </div>
              </div>
            }
          />
          <div className="content-container-business">
            <div className={styles.add_card}>
              <div className={styles.heading}>
                <div className={styles.head_text}>Details</div>
                <div className={styles.head_active}>
                  <span>
                    <Switch
                      checked={menuItems.is_default}
                      onChange={() => {
                        onActivate();
                      }}
                    />
                  </span>
                  <span className={styles.swith_label}>Active</span>
                </div>
              </div>
              <div className={styles.sub_heading}>
                Add Details of the Restaurant.
              </div>
              <Row>
                <Col className={styles.upload_wrap}>
                  <div name="photo_url">
                    <Upload
                      className={styles.upload_btn}
                      fileList={[]}
                      customRequest={uploadImage}
                    >
                      {menuItems.photo_url ? (
                        <div className={styles.uploaded_img}>
                          <img
                            src={menuItems.photo_url}
                            alt="avatar"
                            style={{
                              height: "100%",
                              width: "100%",
                            }}
                          />
                        </div>
                      ) : (
                        <div className={styles.menu_upload}>
                          <div>
                            <img src="/images/upload.png" alt="FoodLuv" />
                            <p>Click or drag file to this area to upload</p>
                          </div>
                        </div>
                      )}
                    </Upload>
                  </div>
                </Col>
                <Col className={styles.form_area}>
                  <div
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: "Please provide the menu name",
                      },
                    ]}
                  >
                    <label>Name</label>
                    <Input
                      placeholder="Provide the menu name"
                      name="name"
                      value={menuItems.name}
                      onChange={(e) => {
                        onUpdateValue(e);
                      }}
                    />
                  </div>
                  <div
                    label="Restaurant Name"
                    rules={[
                      {
                        required: true,
                        message: "Please provide the menu name",
                      },
                    ]}
                  >
                    <label>Restaurant Name</label>
                    <Select
                      style={{ width: "100%" }}
                      value={menuItems.restaurant_ids}
                      mode="multiple"
                      showArrow
                      placeholder=""
                      onChange={onSelectChange}
                    >
                      {restaurants &&
                        restaurants.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                  <div className={styles.date_wrap}>
                    <div className={styles.date_area}>
                      <label>Start Time</label>
                      <TimePicker
                        format="HH:mm"
                        name="start_time"
                        value={
                          menuItems.start_time
                            ? moment(menuItems.start_time, "HH:mm")
                            : null
                        }
                        onChange={(time, timeString) =>
                          onTimeChange(timeString, "start_time")
                        }
                      />
                    </div>
                    <div className={styles.date_area}>
                      <label>End Time</label>
                      <TimePicker
                        format="HH:mm"
                        name="end_time"
                        value={
                          menuItems.end_time
                            ? moment(menuItems.end_time, "HH:mm")
                            : null
                        }
                        onChange={(time, timeString) =>
                          onTimeChange(timeString, "end_time")
                        }
                      />
                    </div>
                  </div>
                  <div className={styles.menu_type} style={{flexWrap:"wrap",gap:"10px"}}>
                    <div>Menu Type</div>
                    <Radio.Group
                      onChange={onMenuChange}
                      value={menuItems.type}
                      className={styles.type_list}
                    >
                      {isCatering? 
                      <Radio value={"CATERING"}>CATERING</Radio> :
                      <>
                      <Radio value={"CATERING"}>CATERING</Radio>
                      <Radio value={"POS"}>POS</Radio>
                      <Radio value={"ONLINE"}>ONLINE</Radio>
                      </>
}
                    </Radio.Group>
                  </div>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className={styles.submit_btn}
                    onClick={submitForm}
                  >
                    Save & Add
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(MenuForm));
